export default __webpack_public_path__ + "static/media/water.fcf80fc8.jpg";